import cn from 'classnames';
import { IconProps } from 'components/Shared/Icon/index';
import { iconStyles } from 'components/Shared/Icon/iconStyles';
import styles from './styles.scss';

export const IconStores = (props: IconProps) => (
  <svg
    className={cn(styles.stores, iconStyles(props))}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path id="a" d="M0 0h21v21H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <path
        fill="#FFF"
        d="M4.2 15.5217c0 .5042.333.913.7437.913h.1926c.4107 0 .7437-.4088.7437-.913s-.333-.913-.7437-.913h-.1926c-.4107 0-.7437.4088-.7437.913"
        mask="url(#b)"
      />
      <path
        fill="#FFF"
        d="M17.8686 10.0146c-.9807 0-1.7782-.855-1.7782-1.9063 0-.4001-.3027-.7254-.6766-.7254-.3732 0-.6759.3253-.6759.7254 0 1.0513-.7975 1.9063-1.7782 1.9063-.9815 0-1.779-.855-1.779-1.9063 0-.4001-.3034-.7254-.6766-.7254h-.003c-.3732 0-.6758.3253-.6758.7254 0 1.0513-.7975 1.9063-1.7782 1.9063-.9815 0-1.779-.855-1.779-1.9063 0-.4001-.3034-.7254-.6766-.7254-.0015 0-.0023.0008-.003.0008-.0008 0-.0015-.0008-.003-.0008-.3732 0-.6766.3253-.6766.7254 0 1.0513-.7975 1.9063-1.7782 1.9063-.941 0-1.7137-.7882-1.7745-1.78l2.4811-6.7855h13.3254l2.4811 6.7855c-.0608.9918-.8335 1.78-1.7752 1.78zm.6045 9.5355H8.6553v-8.1517c.7495-.1594 1.3938-.6126 1.8473-1.2341.5745.785 1.4568 1.3001 2.4571 1.3001.9995 0 1.8811-.5144 2.454-1.2985.5738.7841 1.4554 1.2985 2.4549 1.2985.2065 0 .4085-.0241.6045-.0652v8.151zm-11.1695 0H2.5262v-8.1509c.196.041.398.0652.6045.0652 1.0017 0 1.8848-.516 2.4578-1.3025.4265.5844 1.0228 1.0135 1.7151 1.1963v8.192zM21 8.1083a.7688.7688 0 0 0-.0473-.264L18.253.4604C18.1517.1827 17.9016 0 17.6238 0H3.3762c-.2778 0-.5279.1827-.6293.4605L.0473 7.8442A.7688.7688 0 0 0 0 8.1082c0 1.0555.4663 1.9877 1.179 2.6027 0 .0105-.0045.0185-.0045.0282v9.5356c0 .4.3026.7253.6758.7253H19.149c.3733 0 .6759-.3252.6759-.7253V10.739c0-.0097-.0045-.0177-.0045-.0274C20.5337 10.0967 21 9.1637 21 8.1083z"
        mask="url(#b)"
      />
    </g>
  </svg>
);
